module.exports = __webpack_public_path__ + "images/checked-disabled-f2147a.svg";